import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styled, { css } from "styled-components";
import Block from "components/layout/Block";
import { breakpoints } from "styles/grid";

// #####################################################

const StyledPaginationBullet = styled.span`
	display: inline-block;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	margin: 0 6px;
	cursor: pointer;
	background: #a9a9a9;
	opacity: 0.4;
	transform: scale(${({ $scale }) => $scale});
	transition: 400ms transform;

	${({ $isActive, $isDarkMode, $multiColor, $isWelcomeSlider }) => {
		if ($isWelcomeSlider) {
			return $isActive && $isDarkMode
				? css`
						background: var(--color-whiteTrueAlways-darken-200);
						opacity: 1;
						@media (max-width: ${breakpoints.desktop - 1}px) {
							opacity: 1;
						}
				  `
				: $isActive &&
						css`
							background: var(--color-whiteTrueAlways-darken-200);
							opacity: 1;
							@media (max-width: ${breakpoints.desktop - 1}px) {
								background: var(--color-primary-always);
								opacity: 1;
							}
						`;
		} else {
			if ($multiColor) {
				return $isActive && $isDarkMode
					? css`
							background: var(--color-whiteTrueAlways-darken-200);
							opacity: 1;
					  `
					: $isActive &&
							css`
								background: var(--color-primary-always);
								opacity: 1;
							`;
			} else {
				return (
					$isActive &&
					css`
						background: var(--color-whiteTrueAlways-darken-200);
						opacity: 1;
					`
				);
			}
		}
	}}
`;

// #####################################################

const SliderPaginationAlwaysMiddle = ({
	activeSlide,
	swiper,
	multiColor = false,
	isWelcomeSlider = false,
}) => {
	const isDarkMode = useSelector(
		(state) => state.globalCommon?.darkMode?.isDarkMode
	);
	const [isAnimating, setIsAnimating] = useState(false);

	const paginationItems = [];

	const getBulletScale = (index) => {
		const distanceFromActive = Math.abs(0 - index);
		if (distanceFromActive === 0) return 1;
		if (distanceFromActive === 1) return 0.7;
		if (distanceFromActive === 2) return 0.4;
		return 0.5;
	};

	const getBulletScaleAnimating = (index) => {
		const distanceFromActive = Math.abs(0 - index);
		if (distanceFromActive === 0) return 0.8;
		if (distanceFromActive === 1) return 0.9;
		if (distanceFromActive === 2) return 0.6;
		return 0.5;
	};

	useEffect(() => {
		setIsAnimating(true);
		const timer = setTimeout(() => {
			setIsAnimating(false);
		}, 200);

		return () => clearTimeout(timer);
	}, [activeSlide]);

	for (let i = -2; i < 3; i++) {
		const scale = isAnimating
			? getBulletScaleAnimating(i)
			: getBulletScale(i);

		paginationItems.push(
			<StyledPaginationBullet
				key={i}
				onClick={() => {
					swiper.slideTo(swiper.realIndex + i);
				}}
				$isActive={i === 0}
				$scale={scale}
				$isDarkMode={isDarkMode}
				$multiColor={multiColor}
				$isWelcomeSlider={isWelcomeSlider}
			/>
		);
	}

	return (
		<Block flex justifyCenter alignCenter>
			{paginationItems}
		</Block>
	);
};

// #####################################################

export default SliderPaginationAlwaysMiddle;
